<template>
  <div>
    <div>
      <Form :model="searchData" inline>
        <FormItem prop="gas_name">
          <Input type="text" v-model="searchData.gas_name" placeholder="站点名称" class="lx-search-item"></Input>
        </FormItem>
        <!--<FormItem prop="station_type" label="渠道:" :label-width="60">
          <Select v-model="searchData.platform">
            <Option value="">全部</Option>
            <Option v-for="item in platform" :value="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>-->
        <FormItem label="省市区：" prop="province" style="width:450px">
          <Select v-model="searchData.province_name" style="width: 25%" placeholder="省" @on-change="changeProvince">
            <Option value="">请选择</Option>
            <Option v-for="(item,key) in provinces" :value="item" :key="key">{{item}}</Option>
          </Select>
          <Select v-model="searchData.city_name" style="width: 25%" placeholder="市" @on-change="changeCity">
            <Option value="">请选择</Option>
            <Option v-for="(item,key) in citys" :value="item" :key="key">{{item}}</Option>
          </Select>
          <Select v-model="searchData.county_name" style="width: 25%" placeholder="区">
            <Option value="">请选择</Option>
            <Option v-for="(item,key) in countys" :value="item" :key="key">{{item}}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="doSearch">搜索</Button>
        </FormItem>
        <FormItem style="margin-left:20px">
          <Checkbox
                  :indeterminate="indeterminate"
                  :value="checkAll"
                  @click.prevent.native="checkAllAgentStation">全选</Checkbox>
          <Button type="primary" @click="doSubmit">提交</Button>
        </FormItem>
      </Form>
    </div>

    <div>
      <CheckboxGroup v-model="checked" @on-change="editAgentStationInfoChange" class="custom-checkbox">
        <Checkbox v-for="(item,key) in stations" :label="item.station_id" :key="key" style="width: 45%;white-space: nowrap;overflow: hidden;text-overflow: ellipsis">
          <Tag color="warning">{{item.platform}}</Tag>
          <Tag color="primary">{{item.price2}}</Tag>
          {{item.gas_name}}
        </Checkbox>
      </CheckboxGroup>
    </div>



  </div>
</template>

<script>
  import config from '@/config/base-config'
  export default {
    name: "edit",
    props:{
      id:{
        type:Number,
        default: 0
      },
    },
    data(){
      return {
        searchData:{
          is_search:1,
          gas_name:'',
          platform:'',
          province_name:'',
          city_name:'',
          county_name:'',
        },
        platform:[],
        checkAll:false,
        indeterminate: true,
        checked:[],
        stations:[],
        allStationID:[],
        province_county_data:[],    //省市区数据
        provinces:[],
        citys:[],
        countys:[],
      }
    },
    methods:{
      async getInfo(){
        // let data = await this.$commonFun.postProxy('admin/common/getPageInitInfo',{type:['platform']})
        if (this.id>0){
          let res = await this.$commonFun.postProxy('admin/agent/getAgentStations',{id:this.id,is_search:0});
          this.checked = res.data.checked
          this.allStationID = res.data.all_station_ids
          this.stations = res.data.stations
        }
        this.$commonFun.postProxy('admin/tuanyou/getProvince',{}).then((res)=>{
          this.province_county_data = res.data.province_county_data;
          this.provinces = res.data.province_data
        })

        /*if (this.id>0){
          let res = await this.$commonFun.postProxy('admin/agent/getAgentStations',{id:this.id,is_search:0});
          this.checked = res.data.checked
          this.allStationID = res.data.all_station_ids
          this.stations = res.data.stations
        }*/
      },
      changeProvince(province){
        this.citys = []
        this.province_county_data.forEach((item,key)=>{
          if (item.value === province){
            item.children.forEach(val=>{
              this.citys.push(val.value)
            })
          }
        })
      },
      changeCity(city){
        this.countys=[]
        let province = this.searchData.province_name
        this.province_county_data.forEach((item,key)=>{
          if (item.value === province){
            item.children.forEach((val)=>{
              if (val.value === city){
                val.children.forEach(val=>{
                  this.countys.push(val.value)
                })
              }
            })

          }
        })
      },
      async doSubmit(){
        let params = {
          id:this.id,
          checked:this.checked
        }
        let _self = this
        this.$Modal.confirm({
          content: (!params.checked || params.checked.length<=0) ? '确定要全部下线吗' : '<p>确定提交吗</p>',
          onOk: async () => {
            let res = await _self.$commonFun.postProxy('admin/agent/editAgentStation',params)
            //编辑成功刷新父页面
            this.$commonFun.dealApiResult(res,()=>{
              this.$commonFun.successTip('操作成功',()=>{this.getInfo()})
            })
          },
        });

      },
      async doSearch(){
        this.searchData.id=this.id
        let res = await this.$commonFun.postProxy('admin/agent/getAgentStations',this.searchData)
        this.checked = res.data.checked
        this.allStationID = res.data.all_station_ids
        this.stations = res.data.stations
      },
      editAgentStationInfoChange (data) {
        if (data.length === this.stations.length) {
          this.indeterminate = false;
          this.checkAll = true;
        } else if (data.length > 0) {
          this.indeterminate = true;
          this.checkAll = false;
        } else {
          this.indeterminate = false;
          this.checkAll = false;
        }
      },
      checkAllAgentStation(){
        this.checkAll = this.checked.length !== this.stations.length
        this.indeterminate = false;
        console.log(this.checkAll)
        if (this.checkAll) {
          this.checked = this.allStationID;
        } else {
          this.checked = [];
        }
      },

    },
    mounted() {
      this.getInfo()
    },
  }
</script>

<style scoped lang="less">
  .drawer-footer{
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    background: #fff;
  }

  .info-item{
    >span:nth-child(1){
      min-width: 100px;
      display: inline-block;
      text-align: right;
      letter-spacing: 2px;
      padding: 2px;
    }
    >span:nth-child(2){
      display: inline-block;
      padding-left: 10px;
    }
    .important-word{
      font-weight: bold;
      color: red;
    }
  }

  .provinceCol{
    text-align: center;
    p{
      padding: 5px 0;
      cursor: pointer;
    }
  }

</style>
